
import { defineComponent } from 'vue'
import { APIClient } from '@/api/APIClient'
import { Clasificacion } from '@/api'
import ClasificacionSelect from '@/components/ClasificacionSelect.vue'
import WarningMessage from '@/components/mensajes/WarningMessage.vue'
import ErrorMessage from '@/components/mensajes/ErrorMessage.vue'
import { AxiosError } from 'axios'
import LoaderElement from '@/components/LoaderElement.vue'

export default defineComponent({
  name: 'IndexView',
  components: { ClasificacionSelect, WarningMessage, ErrorMessage, LoaderElement, },
  data () {
    function opt<T> () { return undefined as T | undefined }
    return {
      clasificaciones: [] as Clasificacion[],
      clasificacionElegida: opt<Clasificacion>(),
      busquedaExacta: true,
      fechaInicialDesde: opt<string>(),
      fechaInicialHasta: opt<string>(),
      fechaFinalDesde: opt<string>(),
      fechaFinalHasta: opt<string>(),
      descripcion: opt<string>(),
      seleccionarClasificacionError: false,
      webServiceError: '',
      cargandoClasificaciones: true,
    }
  },
  async created () {
    const client = new APIClient(process.env.BASE_URL)
    try {
      this.clasificaciones = await client.rest.api.clasificacionService.getAll()
    } catch (err) {
      console.error(err)
      const axiosErr = err as AxiosError<string>

      if (axiosErr.response?.status === 404) {
        this.webServiceError = this.$t('errores.webServiceError')
      } else if (axiosErr.response?.status === 500) {
        if (axiosErr.response.data === 'WEB_SERVICE_ERROR') {
          this.webServiceError = this.$t('errores.webServiceError')
        } else {
          this.webServiceError = this.$t('errores.serverError')
        }
      } else {
        this.webServiceError = axiosErr.response?.data ?? axiosErr.message
      }
    } finally {
      this.cargandoClasificaciones = false
    }
    // this.clasificacionElegida?.codigo = this.$route.query.codigoClasificacion?.toString()
    const clasificacionesFlat = myFlat(this.clasificaciones)

    function myFlat (a: Clasificacion[]) : Clasificacion[] {
      return a.reduce(function (flattened, obj) {
        return flattened
          .concat([ obj, ])
          .concat(obj.hijos ? myFlat(obj.hijos) : [])
      }
      , new Array<Clasificacion>())
    }

    if (this.$route.query.codigoClasificacion !== undefined) {
      // this.clasificacionElegida = { codigo: this.$route.query.codigoClasificacion?.toString(), } as Clasificacion
      this.clasificacionElegida = clasificacionesFlat.find(c => c.codigo?.toString() === this.$route.query.codigoClasificacion?.toString())
    }
    this.busquedaExacta = this.$route.query.busquedaExacta?.toString() === 'true'
    this.descripcion = this.$route.query.descripcion?.toString()
    this.fechaFinalDesde = this.$route.query.fechaFinalDesde?.toString()
    this.fechaFinalHasta = this.$route.query.fechaFinalHasta?.toString()
    this.fechaInicialDesde = this.$route.query.fechaInicialDesde?.toString()
    this.fechaInicialHasta = this.$route.query.fechaInicialHasta?.toString()
  },
  methods: {
    buscar () {
      /* if (this.clasificacionElegida === undefined || this.clasificacionElegida.codigo === undefined) {
        this.seleccionarClasificacionError = true
        return
      } */

      this.$router.push({
        path: 'buscar',
        query: {
          codigoClasificacion: this.clasificacionElegida?.codigo,
          busquedaExacta: this.busquedaExacta.toString(),
          fechaInicialDesde: this.fechaInicialDesde,
          fechaInicialHasta: this.fechaInicialHasta,
          fechaFinalDesde: this.fechaFinalDesde,
          fechaFinalHasta: this.fechaFinalHasta,
          descripcion: this.descripcion,
        },
      })
    },
    reset () {
      this.clasificacionElegida = undefined
      this.fechaInicialDesde = undefined
      this.fechaInicialHasta = undefined
      this.fechaFinalDesde = undefined
      this.fechaFinalHasta = undefined
      this.descripcion = undefined
    },
  },
})
